<template>
  <div class="filter-wrapper">
    <div class="d-flex align-items-center">
      <button
        type="button"
        class="filter-btn d-flex align-items-center justify-content-center font-weight-medium mr-0 mr-sm-3"
        @click="openFilter()"
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 5.83333L10 5.83333M10 5.83333C10 6.9379 10.8954 7.83333 12 7.83333C13.1046 7.83333 14 6.9379 14 5.83333C14 4.72876 13.1046 3.83333 12 3.83333C10.8954 3.83333 10 4.72876 10 5.83333ZM6 11.1667L14 11.1667M6 11.1667C6 12.2712 5.10457 13.1667 4 13.1667C2.89543 13.1667 2 12.2712 2 11.1667C2 10.0621 2.89543 9.16667 4 9.16667C5.10457 9.16667 6 10.0621 6 11.1667Z"
            stroke="#212121"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        <span class="ml-1 d-flex align-items-center">
          <span class="mr-1">{{ multiLanguage.All }}</span>
          {{ $translate("Ceres::Template.itemFilter") }}
        </span>
      </button>
      <button
        type="button"
        class="filter-btn d-none d-md-flex align-items-center justify-content-center font-weight-medium mx-3"
        @click="openFilter([29])"
      >
        {{ multiLanguage.Size }}
      </button>
      <button
        type="button"
        class="filter-btn d-none d-md-flex align-items-center justify-content-center font-weight-medium mx-3"
        @click="openFilter([28])"
      >
        {{ multiLanguage.Color }}
      </button>
      <button
        type="button"
        class="filter-btn d-none d-lg-flex align-items-center justify-content-center font-weight-medium mx-3"
        @click="openFilter([25])"
      >
        {{ multiLanguage.Shape }}
      </button>
      <button
        type="button"
        class="filter-btn d-none d-lg-flex align-items-center justify-content-center font-weight-medium mx-3"
        @click="openFilter([27])"
      >
        {{ multiLanguage.Material }}
      </button>
      <button
        type="button"
        class="filter-btn d-none d-lg-flex align-items-center justify-content-center font-weight-medium ml-0 ml-sm-3"
        @click="openFilter([39])"
      >
        {{ multiLanguage.Style }}
      </button>
    </div>

    <div
      class="position-fixed overflow-hidden background-overlay d-none"
      :class="{
        'filter-active': filterActive,
      }"
      @click="closeFilter()"
    ></div>

    <div
      class="category-filter position-fixed bg-white overflow-hidden"
      :class="{
        'filter-active': filterActive,
        'is-loading': isLoading,
      }"
    >
      <div
        class="spinner-border text-white d-none"
        :class="{
          'filter-active': filterActive,
        }"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <div
        class="filter-header position-sticky d-flex align-items-center justify-content-between p-3 bg-white"
      >
        <div class="d-flex align-items-center">
          <button
            type="button"
            @click="closeFilter()"
            :aria-label="$translate('Ceres::Template.itemFilter')"
            class="close-icon"
          >
            ✕
          </button>
          <p class="h4 ml-3">
            {{ multiLanguage.RugFilter }}
          </p>
        </div>
        <button
          v-if="tagList.length >= 1"
          type="button"
          @click="resetAllTags()"
          :aria-label="$translate('Ceres::Template.itemFilterReset')"
          class="btn-reset font-weight-medium small"
        >
          {{ $translate("Ceres::Template.itemFilterReset") }}
        </button>
      </div>

      <div class="filters px-3 overflow-auto" id="facet-filters">
        <item-filter
          v-for="facet in facets"
          :facet="facet"
          :key="facet.id"
          :public-path="publicPath"
          :categoryId="categoryId"
          :active-facets="activeFacets"
          @toggle-facet="handleToggleFacet"
        ></item-filter>
      </div>

      <div
        class="filters-footer position-sticky d-flex justify-content-center p-3 bg-white"
        :class="{
          active: tagList.length > 0,
        }"
      >
        <button
          type="button"
          class="btn btn-primary w-100"
          @click="applyFilters"
          :disabled="isLoading"
        >
          {{ multiLanguage.ApplyFilter }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ItemFilter from "./ItemFilter.vue";

export default {
  name: "item-filter-list",

  components: {
    ItemFilter,
  },

  props: {
    filterListBulk: Boolean,
    facetData: {
      type: Array,
      default() {
        return [];
      },
    },
    multiLanguage: {
      type: Object,
    },
    categoryId: {
      type: Number,
    },
    publicPath: {
      type: String,
    },
    allowedFacetsTypes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      filterActive: false,
      activeFacets: [],
    };
  },

  computed: {
    ...mapState({
      facets(state) {
        let filteredFacets = [];
        if (!this.allowedFacetsTypes.length) {
          filteredFacets = state.itemList.facets;
        } else {
          filteredFacets = state.itemList.facets.filter(
            (facet) =>
              this.allowedFacetsTypes.includes(facet.id) ||
              this.allowedFacetsTypes.includes(facet.type)
          );
        }
        filteredFacets.sort((a, b) => b.position - a.position);
        return filteredFacets;
      },
      tagList: (state) => state.itemList.selectedFacets,
      isLoading: (state) => state.itemList.isLoading,
    }),
  },

  methods: {
    ...mapActions(["applyFilters"]),

    openFilter(facetIds = [5]) {
      this.filterActive = true;
      this.activeFacets = facetIds;
      document.querySelector("body").classList.add("fixed-active");
    },
    closeFilter() {
      this.filterActive = false;
      this.activeFacets = [];
      document.querySelector("body").classList.remove("fixed-active");
    },
    handleToggleFacet(facetId) {
      const index = this.activeFacets.indexOf(facetId);
      if (index > -1) {
        this.activeFacets.splice(index, 1);
      } else {
        this.activeFacets.push(facetId);
      }
      this.activeFacets = [...this.activeFacets];
    },
    resetAllTags() {
      this.resetAllSelectedFacets();
      this.loadItemList();
    },

    ...mapMutations(["resetAllSelectedFacets"]),

    ...mapActions(["loadItemList"]),
  },

  created() {
    if (!this.$store.state.itemList.facets?.length) {
      this.$store.commit("addFacets", this.facetData);
    }
  },
};
</script>
